/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MessageSquareLock = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2" }],
    ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5" }],
    ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1" }]
  ]
];

export { MessageSquareLock as default };
//# sourceMappingURL=message-square-lock.js.map
